module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-planner-044ec0535ce859a2a0dfb7de560dfaa9.png";